module.exports = __webpack_public_path__ + "3bcdfb8dbbeba54568cba2759ff1a0c2.svg";